import { BlockContent } from "src/quiz";


export function loadHeader(headerData: string) {
  return JSON.parse(headerData) as BlockContent;
}
